<template>
  <div class="all">
    <headercon></headercon>
    <div class="content-box">
      <div class="box-1">
        <img class="icon" src="../assets/download_logo.png" />
        <div class="intro-box">
          <p class="title">数泽App</p>
          <p class="intro">数泽App主要为用户提供数字文创作品的浏览、展示、收藏记录及相关信息查询服务。平台通过区块链技术对数字文创作品的基础信息进行存证，用于提升作品信息的可追溯性与防篡改能力。本应用不涉及虚拟货币发行或交易。</p>
        </div>
        <img class="icon" src="../assets/download_url.png" />
        <div>
          <div class="flex">
            <img src="../assets/download_android.png" />
            <p>安卓版</p>
          </div>
          <div class="flex mt">
            <img src="../assets/download_ios.png" />
            <p class="gray">IOS版本敬请期待</p>
          </div>
          <div class="download" @click="onDownload">
            <img src="../assets/download_btn.png" />
            <p>立即下载</p>
          </div>
        </div>
      </div>
      <img class="content-img" style="margin-top: 15px;" src="../assets/download_content1.png" />
      <img class="content-img" style="margin-top: 15px;" src="../assets/download_content2.png" />
      <img class="content-img" style="margin-top: 15px;" src="../assets/download_content3.png" />
    </div>
  </div>
</template>

<script>
import headercon from './header'

export default {
  components: {
    headercon
  },
  data () {
    return {}
  },
  methods: {
    onDownload () {
      location.href = 'https://download.siisoo.com/shuze.apk'
    }
  }
}
</script>

<style scoped lang="less">
p {
  margin-block-start: 0em;
  margin-block-end: 0em;
}

.all {
  background: url("../assets/details.png");
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  min-width: 1199px;
  /deep/ .li6 {
    list-style-type: none;
    float: left;
    text-decoration: none;
    text-align: center;
    background: #fff;
    width: 100px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    border-radius: 25px;
    a {
      color: #757575;
      text-decoration: none;
    }
  }
}
.content-box {
  margin-left: 20%;
  width: 60%;
  min-height: 70%;
  max-height: 80%;
  overflow-y: scroll;
  font-size: 0;
  position: relative;
  padding-bottom: 70px;

  .box-1 {
    position: relative;
    display: flex;
    align-items: center;
    padding: 20px 50px 20px 20px;
    background-color: rgba(255, 255, 255, 0.3);
    border-radius: 30px;

    .icon {
      width: 160px;
      height: 160px;
      margin-right: 30px;
    }

    .intro-box {
      flex: 1;
      margin-right: 58px;
      text-align: left;

      .title {
        color: #000;
        font-size: 28px;
        font-weight: bold;
      }

      .intro {
        margin-top: 8px;
        color: #000;
        font-size: 16px;
        line-height: 30px;
      }
    }

    .flex {
      display: flex;
      align-items: center;

      img {
        width: 26px;
        height: 26px;
        margin-right: 10px;
      }

      p {
        color: #000;
        font-size: 20px;
      }

      .gray {
        color: #9D9D9D;
      }
    }

    .mt {
      margin-top: 20px;
    }

    .download {
      width: 160px;
      height: 50px;
      background: linear-gradient( 90deg, #7285FF 0%, #56C3FF 100%), rgba(0,0,0,0.2);
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 20px;
      cursor: pointer;

      img {
        width: 20px;
        height: 20px;
        margin-right: 10px;
      }

      p {
        color: #fff;
        font-size: 20px;
      }
    }
  }

  .content-img {
    width: 100%;
    height: auto;
    object-fit: contain;
  }
}

@media (max-width: 1500px) {
.content-box {
  padding-bottom: 45px;

  .box-1 {
    padding: 15px 30px 15px 15px;
    border-radius: 20px;

    .icon {
      width: 107px;
      height: 107px;
      margin-right: 10px;
    }

    .intro-box {
      margin-right: 25px;

      .title {
        font-size: 20px;
      }

      .intro {
        margin-top: 4px;
        font-size: 12px;
        line-height: 20px;
      }
    }

    .flex {
      img {
        width: 17px;
        height: 17px;
        margin-right: 7px;
      }

      p {
        font-size: 13px;
      }
    }

    .mt {
      margin-top: 15px;
    }

    .download {
      width: 107px;
      height: 33px;
      border-radius: 8px;
      margin-top: 15px;

      img {
        width: 13px;
        height: 13px;
        margin-right: 7px;
      }

      p {
        font-size: 13px;
      }
    }
  }

  .content-img {
    width: 100%;
    height: auto;
    object-fit: contain;
  }
}
}
</style>



// WEBPACK FOOTER //
// src/components/download.vue